module.exports = __webpack_public_path__ + "static/media/onboardingpre.8bc6704b.png";